import { FigureVarSettingsDto, isFigureVarSettingsDto } from "./FigureVarSettingsDto";

/**
 * Defines the settings for a single axis type within a figure.
 */
export interface FigureAxisSettingsDto {
  axisType: string;
  parameters: FigureVarSettingsDto[];
}

/**
 * Type guard to check if an object is a FigureAxisSettingsDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the figure axis settings shape.
 */
export const isFigureAxisSettingsDto = (obj: unknown): obj is FigureAxisSettingsDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureAxisSettingsDto;
  if (typeof chkObj.axisType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.parameters)) {
    return false;
  }
  if (chkObj.parameters.some((parameter) => !isFigureVarSettingsDto(parameter))) {
    return false;
  }
  return true;
};
